import React, {useContext, useState} from 'react';
import OrgPage from "../../../components/OrgPage";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import {SystemManager_API} from "../SystemManager.API";
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from "moment";
import icons from "../../../assets/icons";
import {Checkbox} from "@material-ui/core";
import {formatDate} from "../../../utils/utils";
import CheckboxInput from "../../../components/Inputs/CheckboxInput/CheckboxInput";
import CheckboxCell from "../../../components/Pages/TablePage/Table/Cells/CheckboxCell";
import {useAPI} from "../../../hooks/useAPI";
import {AuthContext} from "../../../context/AuthContext";

const {
    getErrors,
    approve
} = SystemManager_API.doctors

function DiagnosesMismatch() {

    const [refresh, setRefresh] = useState(false)

    const {token} = useContext(AuthContext)
    const linkToDiagnosesMismatchViewer = id => `https://profdoctor.net/mismatch/system-manager/${id}`


    return (
        <OrgPage
            url={`${process.env.REACT_APP_BASE_URL}` + getErrors(token.userId).api}
            refresh={refresh}
			defaultSortBy={{name: 'date', method: 1, ready: ''}}
            exportTemplateButtons={{export: false, registry: false}}
            filterBarButtons={{downloadTemplate: {show: false,}}}
            filterFieldsConf={{
                fio: true,
                doctor: true,
                date: true,
                period: true,
                success: true
            }}
            breadCrumbsItems={[
                {title: 'Доктор'},
                {title: 'Несовпадение диагнозов', actual: true},
            ]}

            firstRow={[
                {title: 'ФИО', id: "fio"},
                {title: 'Дата', id: "date"},
                {title: 'Описание 1 / Доктор', style: {width: '250px'}},
                {title: 'Описание 2 / Доктор', style: {width: '250px'}},
                {title: 'Описание 3 / Доктор', style: {width: '250px'}},
                {title: 'Выполнено'},
            ]}

            haveToShow={[
                {
                    type: 'wrapperCell',
                    typeData: {
                        cell: props => <LinkCell3 linkTitle={<a title={props.all?.fio}
                                                                href={linkToDiagnosesMismatchViewer(props?.all?.id)}>{props.all?.fio}</a>}/>
                    }
                },
                {
                    type: 'wrapperCell',
                    typeData: {cell: props => <LinkCell3 linkTitle={formatDate(props.all?.result_date)}/>}
                },
                {
                    type: 'wrapperCell', typeData: {
                        cell: props => <DoctorDiagnosis status={props.all?.diagnozies[0]?.diagnozies?.shortResult}
                                                        name={props.all?.diagnozies[0]?.doctor_info.fio}/>
                    }
                },
                {
                    type: 'wrapperCell', typeData: {
                        cell: props => <DoctorDiagnosis status={props.all?.diagnozies[1]?.diagnozies?.shortResult}
                                                        name={props.all?.diagnozies[1]?.doctor_info.fio}/>
                    }
                },
                {
                    type: 'wrapperCell', typeData: {
                        cell: props => <DoctorDiagnosis status={props.all?.diagnozies[2]?.diagnozies?.shortResult}
                                                        name={props.all?.diagnozies[2]?.doctor_info.fio}/>
                    }
                },
                {
                    type: 'wrapperCell', typeData: {
                        cell: props => <CheckApprove checked={props.all?.checked} id={props.all.id}/>
                    }
                },

            ]}
        />
    );
}

const DoctorDiagnosis = (props) => {

    const result = props.status === "Без патологических изменений" ? "Норма" : props.status

    return (
        props.name ?
            <StyledDoctorDiagnosis status={result === "Норма"}>
                <div className="status">{result} </div>
                <div className="name" title={props.name}>/ {props.name}</div>
            </StyledDoctorDiagnosis>
            : ''
    )
}

const StyledDoctorDiagnosis = styled.div`
  display: flex;
  width: 100%;
  font-weight: normal;
  height: max-content;
  padding-left: 10px;
  padding-right: 10px;

  .status {
    color: ${p => p.status ? "#07B51A" : '#FF007C'};
    font-weight: normal;
    font-size: 14px;
    margin-right: 3px;

  }

  .name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: normal;
    font-size: 14px;
    height: max-content;
  }
`
DoctorDiagnosis.propTypes = {
    status: PropTypes.bool,
    name: PropTypes.string
}

const CheckApprove = props => {
    const [checked, setChecked] = useState(props.checked)
    const userId = useContext(AuthContext)?.token?.userId
    const {APIRequest} = useAPI()

    const clickHandler = async () => {
        await APIRequest(approve(userId, props.id)).then(res => res.status === 200 || res.status === 201 && setChecked(res?.body?.data?.checked))
    }

    return (
        <StyledCheckApprove onClick={clickHandler}>
            <CheckboxInput checked={checked}/>
        </StyledCheckApprove>
    )

}
const StyledCheckApprove = styled.div`
  padding-left: 5px;
`
export default DiagnosesMismatch;

